import { adminRequestsApi } from 'entities/adminRequest/api/adminRequestsApi';
import { makeAutoObservable, runInAction } from 'mobx';

export type AdminRequestData = {
  id: string;
  name: string;
  email: string;
};

export class AdminRequestModel {
  public isPending = false;
  public isError = false;
  private _data: AdminRequestData;

  public get id() {
    return this._data.id;
  }
  public get name() {
    return this._data.name;
  }
  public get email() {
    return this._data.email;
  }

  constructor(data: AdminRequestData) {
    this._data = data;
    makeAutoObservable(this);
  }

  public async accept() {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    try {
      await adminRequestsApi.accept(this.id, this.email, this.name);
    } catch (e) {
      runInAction(() => {
        this.isPending = false;
        this.isError = true;
      });
      console.error(e);
    }
  }
  public async decline() {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    try {
      await adminRequestsApi.decline(this.id, this.email, this.name);
    } catch (e) {
      runInAction(() => {
        this.isPending = false;
        this.isError = true;
      });
      console.error(e);
    }
  }
}
